import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useMutation } from '@apollo/client'
import FileUpload from './FileUpload'
import Modal from './Modal'
import { ImportUsers } from '../graphql/mutations'

const ImportUsersModal = ({
    show,
    close,
    onSuccess,
}) => {

    const { t } = useTranslation()
    const [error, setError] = useState()
    const [loading, setLoading] = useState(false)
    const [importMutation] = useMutation(ImportUsers)

    const handleImport = async (file) => {
        setLoading(true)
        
        try {
            const res = await importMutation({
                variables: {
                    file,
                },
            })

            if (res?.data?.importUsers?.items?.length > 0) {
                const failList = res.data.importUsers.items.map(x => `(${x.error}) Name: ${x.name}, PID: ${x.pid}, IPI: ${x.ipi}`)
                setError(`${t('users.import_error')}\n\n${failList.join('\n\n')}`)
                return
            }

            if (res?.data?.importUsers?.code === 'SUCCESS') {
                if (onSuccess) onSuccess()
                return
            }

            setError(t('users.import_error'))
        } catch (err) {
            setError(t('users.import_error'))
            console.log(err)
        } finally {
            setLoading(false)
        }
    }

    const handleClose = () => {
        if (close) close()
        setError(null)
    }

    return (
        <Modal
            className={'modal-bonuses'}
            show={show}
            close={handleClose}
            title={ t('users.import') }
        >
            <FileUpload
                handleUpload={handleImport}
                loading={loading}
            />

            {
                error ?
                <div className='error-message'>
                    <span>{ error }</span>
                </div>
                :
                <></>
            }
        </Modal>
    )
}

export default ImportUsersModal